export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER'
export const SET_LOGIN = 'SET_LOGIN'
export const SET_USER = 'SET_USER'
export const SET_BENEFICIARIES = 'SET_BENEFICIARIES'
export const SET_PROVINCE_WITH_THEIR_BENEFICIARIES =
  'SET_PROVINCE_WITH_THEIR_BENEFICIARIES'
export const SET_SNACKBAR = 'SET_SNACKBAR'
export const SET_SNACKBAR_DETAILS = 'SET_SNACKBAR_DETAILS'
